import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "common/api/httpClient";
import { Workspace } from "../model";

type WorkspacesState = {
  isLoading: boolean;
  isReloadNeeded: boolean;
  error?: string;
  workspaces: Workspace[];
};

const initialState: WorkspacesState = {
  isLoading: false,
  isReloadNeeded: true,
  workspaces: [],
};

export const getAllWorkspaces = createAsyncThunk(
  "Admin/Workspaces/getAllWorkspaces",
  async () => {
    const response = await httpClient.get<Workspace[]>(
      "FormDefinition/workspaces"
    );
    return response.data;
  }
);

export const developerWorkspacesSlice = createSlice({
  name: "developer/workspaces",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllWorkspaces.pending, (state) => {
      state.isLoading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWorkspaces.fulfilled,
      (state, action: PayloadAction<Workspace[]>) => {
        state.isLoading = false;
        state.isReloadNeeded = false;
        state.workspaces = action.payload;
      }
    );
    builder.addCase(getAllWorkspaces.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});
